// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ReportList {
  CostSummaryReportViewModel_SA = 42,
  CostByPartNumberViewModel_SA = 18,
  Costs_PlannedAndNonPlanned_ReportViewModel_SA = 39,
  CostDetailsByDisciplineReportViewModel_SA = 14,
  LaborCostsByDisciplineReportViewModel_SA = 95,
  SA_DetailedFeesByPeriodReportViewModel = 66,
  SASubcontractorReportViewModel = 57,
  TravelCostsReportViewModel_SA = 98,
  MaintenancePlanningReportViewModel_SA = 52,
  GenericMaterialReportViewModel_SA = 15,
  SubmittalCostbyDisciplineReportViewModel_SA = 89,
  SubmittalServicesReportViewModel_SA = 54,
  SubmittalRiskByDisciplineViewModel_SAs = 67,
  ServiceDefinitonsReportViewModel_SA = 22,
  EstimateOverviewReport_SAViewModel = 31,
  CostandLaborDetailsbyPeriodReportViewModel_SA = 50,
  EquipmentInventoryReportViewModel_SA = 51,
  ServicesMaintenancePlanningReportViewModel = 53,
  CostReviewCheckListReportViewModel = 78,
  EstimateSummaryReportViewModel = 13,
  CostByPartNumberExpandedViewModel = 24,
  CostByPartNumberByTypeExpandedViewModel = 63,
  CostByLevelViewModel = 48,
  SubcontrctorAndMiscCostViewModel = 71,
  ApplicationDetailViewModel = 37,
  MaterialTakeOffAndExtensionReportViewModel = 29,
  LaborHoursDistViewModel = 92,
  EstimateMaterialBreakdownViewModel = 77,
  PartsByCountryViewModel = 21,
  ServiceContractMaterialViewModel = 59,
  ControllerMaterialViewModel = 44,
  SystemNotesViewModel = 34,
  SpecialPricingViewModel = 81,
  TaskBasedLaborSummaryViewModel = 56,
  TaskBasedLaborByAreaViewModel = 11,
  UsedSymbolViewModel = 69,
  WiringUsedViewModel = 85,
  ZeroCostMaterialByPartNumberViewModel = 49,
  MaterialViewModel = 36,
  TakeoffInputByProjectViewModel = 26,
  SubmittalReportViewModel = 58,
  PriceSummaryViewModel = 16,
  NetSalesPricingViewModel = 28,
  PPMLaborHoursViewModel = 33,
  LaborHoursByPeriodReportViewModel_SA = 83,
  LaborHoursBySalesOfficeReportViewModel = 88,
  CostReviewCheckListReportViewModelSa = 79,
  DscOperationsMaintenancePlanningReportViewModelSa = 80,
  TaskByLevelReportViewModel = 82,
  LaborByLevelReportViewModel = 84,
  MaterialWithNotesByAreaViewModel = 60,
  TaskByLevelWithNotesViewModel = 61,
  SubContractorMiscNotesViewModel = 72,
  DataOnlyMaintenancePlanningReportViewModel = 64,
  ElectricalServicesMaterialAndHoursViewModel = 47,
  LaborByDisciplineReportViewModel_SA = 10,
  LaborByDisciplineByAreaReportViewModel_SA = 12,
  LaborByDisciplineByPeriodReportViewModel_SA = 55,
  MaterialByPartTypeViewModel = 38,
  SystemsReportViewModel = 35,
  FireEstimatingAnalyticsReportViewModel = 97,
  MaterialByTypeViewModel = 96,
  ServicesNotesViewModel = 93,
  LegacyCostBreakdownByDisciplineByPeriodViewModel_SA = 86,
  HybridPricingReportViewModel_SA = 70,
}
